// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"f629e170","331":"eb5ce5bd","505":"a20973ee","723":"9b3ae295","812":"f16ffc57"}[chunkId] + ".chunk.js";
};